/** Environment-specific — do not overwrite when promoting theme to production. */
export const RESTAURANT_ID = '156f958b-5075-44dd-92c9-0112955c2c9c';

/** Guests cannot change restaurant — always this outlet. */
export const FIXED_RESTAURANT = true;

/** Used when no table is in the URL or storage (e.g. walk-in / direct link). */
export const DEFAULT_TABLE = 'N/A';
